import capitalize from 'lodash/capitalize';
import { useMemo } from 'react';
import InfoDetailsSet from '@/modules/issuer-dashboard/components/InfoDetailsSet.tsx';
import { InfoCard } from 'ui';
import { ShareholderExtendResponse } from 'api';

interface ShareholderContactDetailsProps {
  shareholder?: ShareholderExtendResponse | null;
}

const ShareholderContactDetails = ({ shareholder }: ShareholderContactDetailsProps) => {
  const contactDetailsData = useMemo(() => {
    const additionalEmailsData = (shareholder?.additional_emails || []).map((email, index) => ({
      label: `Additional email #${index + 1}`,
      value: email,
    }));

    return [
      {
        label: 'Preferred way to communicate',
        value: capitalize(shareholder?.preferred_contact_way),
      },
      {
        label: 'Automatic email notifications',
        value: shareholder?.notifications_enabled ? 'Enabled' : 'Disabled',
      },
      { label: 'Email address', value: shareholder?.email },
      ...additionalEmailsData,
      { label: 'Phone number', value: shareholder?.phone_number },
      { label: 'Postal address', value: shareholder?.address },
      { label: 'Post code', value: shareholder?.postcode },
      { label: 'Suburb', value: shareholder?.suburb },
    ];
  }, [shareholder]);
  return (
    <InfoCard title="Contact details">
      <InfoDetailsSet set={contactDetailsData} />
    </InfoCard>
  );
};

export default ShareholderContactDetails;
